import { render } from "./parityChange.vue?vue&type=template&id=42bd9787"
import script from "./parityChange.vue?vue&type=script&lang=ts"
export * from "./parityChange.vue?vue&type=script&lang=ts"

import "./parityChange.vue?vue&type=style&index=0&id=42bd9787&lang=scss"
script.render = render

export default script